export default __webpack_public_path__ + "static/background-box4-65c3072557ba091b63f9bfacdd5a151d.svg";